<template>
  <div class="main-view partners-container">
		<div class="bg-container partners-hero"  :style="{'background-image': 'url(' + require(`../assets/img/bgs/partners-hero.jpg`) + ')'}">
			<h1>Let’s grow together</h1>
			<bg-wave-element></bg-wave-element>
		</div>
		<section class="video-section flex-col">
			<div class="template-inner">
				<h2 class="text-center">The Evergrow opportunity</h2>
				<p class="text-center">We’re building a new way to make work more meaningful, and your impact more powerful. Evergrow’s dual workplace and environmental benefit makes for a powerful sales proposition. Learn more about how you, as an Evergrow partner, can help change employee engagement and grow an extraordinary recurring income in this video.</p>
			</div>
			<div class="video-container">
				<transition name="fade" mode="out-in">
					<div class="img-transition" @click="playPartnersVideo()" v-if="!isPartnersVideoplayer"></div>
					<!-- <iframe v-else src='https://www.youtube.com/embed/6FX5-9--6T4?autoplay=1' frameborder='0' allowfullscreen></iframe> -->
					<iframe v-else src="https://player.vimeo.com/video/457899577?color=ffffff&title=0&byline=0&portrait=0" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
				</transition>
			</div>
		</section>
		<!-- <section class="calculator-section flex-col">
			<div class="template-inner">
				<h2>Grow an extraordinary recurring income</h2>
				<p>Become an Evergrow Reseller and for every member signup, you will earn a recurring commission on net fees, rewards and purchases for the life of the contract. And you’ll get your money just as fast as you earn it, with automatic commission deposits directly into your bank account. Use this simple calculator to see how much you can earn from license fees alone as an Evergrow partner.</p>
				<Calculator />
			</div>
			<div class="stroke-container flex-row">
				<div class="stroke"></div>
				<div class='stroke-container-inner flex-row'>
					<img src="@/assets/img/icons/hands-green.svg" alt="tree-icon">
					<p>Earn additional recurring commission on 25% of the margin on merchandise and gift card reward redemptions and purchases from the Evergrow Shopping Mall.</p>
				</div>
				<div class="stroke"></div>
			</div>
		</section> -->
		<section class="contact-section-container">
			<div class="flex-container column flex-row" id="join-now-href">
				<p>We’re now accepting a limited number of charter sales partners for the Evergrow launch. Register today to be the first to offer Evergrow to your clients. Our quick-connect API enables you to instantly launch a new client with automatic data import and updates. You will receive dedicated account support, full sales collateral, and access to our custom sales partner dashboard for tracking prospects, commissions and environmental{{'\xa0'}}impact.</p>
				<PartnersForm />
			</div>
			<div class="staff-bubbles">
				<img class="staff-img one" src="@/assets/img/staff/staff-1.png" alt="" data-aos="zoom-in">
				<img class="staff-img two" src="@/assets/img/staff/staff-2.png" alt="" data-aos="zoom-in">
				<img class="staff-img three" src="@/assets/img/staff/staff-3.png" alt="" data-aos="zoom-in">
				<img class="staff-img four" src="@/assets/img/staff/staff-4.png" alt="" data-aos="zoom-in">
				<img class="staff-img five" src="@/assets/img/staff/staff-5.png" alt="" data-aos="zoom-in">
				<img class="staff-img six" src="@/assets/img/staff/staff-6.png" alt="" data-aos="zoom-in">
				<img class="staff-img seven" src="@/assets/img/staff/staff-7.png" alt="" data-aos="zoom-in">
				<img class="staff-img eight" src="@/assets/img/staff/staff-8.png" alt="" data-aos="zoom-in">
				<img class="staff-img nine" src="@/assets/img/staff/staff-9.png" alt="" data-aos="zoom-in">
			</div>
		</section>
  </div>
</template>

<script>
	/* eslint-disable */
	import Calculator from '@/components/Calculator.vue'
	import PartnersForm from '@/components/PartnersForm.vue'


	export default {
		name: 'Partners',
		data() {
			return {
				isPartnersVideoplayer: false,
			}
		},
		methods: {
			playPartnersVideo() {
				this.isPartnersVideoplayer = !this.isPartnersVideoplayer;
			},
		},
		components: {
			Calculator,
			PartnersForm
		}
	}
</script>

<style lang="stylus" scoped>
	.partners-container 
		margin-top 117px

	.partners-hero
		background center top / cover no-repeat #fff
		padding 100px 0 240px
		margin-bottom 80px
		position relative
		
		h1 
			color white
			font-size: 85px
			text-align  center

	// ----- VIDEO SECTION -----

	.img-placeholder
		text-align center

	.img-placeholder img 
		width 100%

	.video-section,
	.calculator-section
		display flex
		box-sizing border-box
		// width 70%
		margin 0 auto
		padding-bottom 150px
		justify-content center
		align-items center
	
	.calculator-section
		background url('~@/assets/img/bgs/tan-white-fade.jpg') center top / 100% no-repeat #F0F0E4	
		padding-top 160px
		
	.video-section h2,
	.calculator-section h2
		font-size 50px
		color #333333
		text-align center
		margin 20px 0
	.calculator-section h2
		margin-top 60px
	
	.video-section p,
	.calculator-section p
		width 100%
		margin 0 auto 60px
		color #333333
		text-align center
		font-weight 300
		
	.partners-container .video-section .video-container
		width 80% !important
		max-width 1200px !important
		margin 80px auto 0
		
		.img-transition
			background url('~@/assets/img/partners/reseller-video-placeholder.jpg') center center / cover no-repeat #fff


	.stroke-container
			margin 100px 0
			justify-content center
			align-items center
			width 84%
			
		
		.stroke 
			border-top 1.5px solid #CCCCCC
			height 2px
			// width 18%

		.stroke-container-inner
			// width 41%
			padding 60px
			border 2px solid #CCCCCC
			border-radius 30px
			justify-content center
			align-items center

			img
				margin-right 40px
				width 70px
				
			p
				width unset
				margin 0
				padding 0
				text-align left

// ----- CONTACT SECTION -----
	.flex-container 
		width 90%
		margin 0 auto
		align-items: center

	.flex-container.column { flex-direction: column }


	.contact-section-container {
		background-color: #00A562;
		height: auto;
		width: 100%;
		position: relative;
	}
	.contact-section-container .background-elements .bg-shape-3 {
		bottom: 260px;
		left: 350px;
		width: 16%;
	}
	.contact-section-container .background-elements .bg-shape-4 {
		bottom: 60px;
		right: 300px;
		width: 23%;
	}
	.contact-section-container .flex-container {
		width: 100%;
		position: relative;
		z-index: 100;
	}
	.contact-section-container h2 {
		font-size: 50px;
		color: #fff;
		text-align: center;
		margin: 80px 0 20px;
	}
	.contact-section-container p {
		width: 35%;
		margin-bottom: 60px;
		color: #fff;
		text-align: center;
		padding-top: 150px;
		font-weight: 300;
		padding-bottom: 20px;
	}

	.contact-section-container .staff-bubbles img.staff-img 
		width: 113px
		height: 113px
		position: absolute
		box-shadow: 0px 20px 40px #00000033
		border-radius: 100%
		// opacity: 0;

	.contact-section-container .staff-bubbles img.one {
		left: 16%;
		top: -2%;
	}
	.contact-section-container .staff-bubbles img.two {
		left: 5%;
		top: 12%;
	}
	.contact-section-container .staff-bubbles img.three {
		left: 19%;
		top: 18%;
	}
	.contact-section-container .staff-bubbles img.four {
		left: 13%;
		top: 32%;
	}
	.contact-section-container .staff-bubbles img.five {
		left: 8%;
		top: 51%;
	}
	.contact-section-container .staff-bubbles img.six {
		right: 4%;
		top: -4%;
	}
	.contact-section-container .staff-bubbles img.seven {
		right: 14%;
		top: 11%;
	}
	.contact-section-container .staff-bubbles img.eight {
		right: 9%;
		top: 26%;
	}
	.contact-section-container .staff-bubbles img.nine {
		right: 18%;
		top: 40%;
	}

	@media ( min-width: 1725px ) 
		.partners-hero
			background url('~@/assets/img/bgs/partners-hero.jpg') center bottom / cover no-repeat #fff
	
	@media ( max-width: 1000px ) 	
		.partners-container
			margin-top 90px
			
		.partners-hero 
			padding 80px 20px 60px
			
			h1
				font-size 56px	
			
			svg
				display none
				
		.video-section 
			padding-bottom 0
			margin-bottom 80px
			
			p
				margin-bottom 0
				padding-bottom 0
				
		.contact-section-container p
			width 80%
			padding-top 80px

		.staff-bubbles
			display none
			
		.form-container
			min-width unset	
			width 80%
			padding 30px
</style>